import { useEffect, type FC } from 'react';

const APP_NAME = '3rd Eye';

export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${APP_NAME} — ${title}` : APP_NAME;
  }, [title]);
}

export const PageTitle: FC<{ title: string }> = ({ title }) => {
  usePageTitle(title);
  return null;
};
